if (typeof $ === 'function') {

  //collect links to be initialized with fancybox
  //-----------------------------------------------
  var links = $('.gallery--link')
    .add($('.page--content p > a > img:not(.icon)').closest('a'))
    .add(
      //include common and also system pages content links to images
      $('.page--content, .system-section--content')
        //@se https://blog.filestack.com/thoughts-and-knowledge/complete-image-file-extension-list/
        .find('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[href$=".webp"], a[href$=".bmp"], a[href$=".jp2"], a[href$=".svg"], a[href$=".svgz"]')
    )
    //exclude cover photos thumbnails
    //as they are managed in page_cover.js
    .not('.page_cover--link__thumb')
    //explicit exclude
    .not('.no-lightbox');
    //console.log(links);

  //add data attributes
  //---------------------
  links.each(function () {
    var t = $(this),
        alt = t.find('img').attr('alt');

    //captions from alts
    if (!t.data('caption') && alt) {
      t.attr('data-caption', alt);
    }

    //galleries
    //make a gallery from all images in the page
    t.attr('data-fancybox', 'gallery');

  });

  //initialize fancybox
  //---------------------
  var buttons = [
        'zoom',
        //'share',
        //'slideShow',
        //'fullScreen',
        //'download',
        //'thumbs',
        'close'
      ];

  //dynamic options
  if (links.filter('.downloadable').length || links.closest('.gallery.downloadable').length) {
    buttons.unshift('download');
  }

  //initialization
  links.fancybox({

  	// Options will go here
    //@see http://fancyapps.com/fancybox/3/docs/#options

    preventCaptionOverlap: true,
    arrows: true,

    // Should display counter at the top left corner
    infobar: true,

    // Should display close button (using `btnTpl.smallBtn` template) over the content
    // Can be true, false, "auto"
    // If "auto" - will be automatically enabled for "html", "inline" or "ajax" items
    smallBtn: 'auto',

    // Should display toolbar (buttons at the top)
    // Can be true, false, "auto"
    // If "auto" - will be automatically hidden if "smallBtn" is enabled
    toolbar: 'auto',

    // What buttons should appear in the top right corner.
    // Buttons will be created using templates from `btnTpl` option
    // and they will be placed into toolbar (class="fancybox-toolbar"` element)
    buttons: buttons,
    image: {
      // Wait for images to load before displaying
      //   true  - wait for image to load and then display;
      //   false - display thumbnail and load the full-sized image over top,
      //           requires predefined image dimensions (`data-width` and `data-height` attributes)
      preload: false
    },

    // Open/close animation type
    // Possible values:
    //   false            - disable
    //   'zoom'           - zoom images from/to thumbnail
    //   'fade'
    //   'zoom-in-out'
    //
    animationEffect: 'zoom',

    // Duration in ms for open/close animation
    //default is 366
    animationDuration: 300,

    // Custom CSS class for slide element
    slideClass: '',

    // Custom CSS class for layout
    baseClass: '',

    // Should image change opacity while zooming
    // If opacity is 'auto', then opacity will be changed if image and thumbnail have different aspect ratios
    //default is 'auto'
    zoomOpacity: true,

    // Transition effect between slides
    //
    // Possible values:
    //   false            - disable
    //   'fade'
    //   'slide'
    //   'circular'
    //   'tube'
    //   'zoom-in-out'
    //   'rotate'
    //
    transitionEffect: 'fade',

    // Duration in ms for transition animation
    //default is 366
    transitionDuration: 300,

    // Hide browser vertical scrollbars; use at your own risk
    //default is true
    hideScrollbar: false,

    thumbs: {
      autoStart: false, // Display thumbnails on opening
      hideOnClose: true, // Hide thumbnail grid when closing animation starts
      parentEl: '.fancybox-container', // Container is injected into this element
      axis: 'y' // Vertical (y) or horizontal (x) scrolling
    },

    // Use mousewheel to navigate gallery
    // If 'auto' - enabled for images only
    wheel: 'auto',


    // Callbacks
    //==========

    // See Documentation/API/Events for more information
    // Example:
    /*
      afterShow: function( instance, current ) {
        console.info( 'Clicked element:' );
        console.info( current.opts.$orig );
      }
    */

    onInit: $.noop, // When instance has been initialized

    beforeLoad: $.noop, // Before the content of a slide is being loaded
    afterLoad: $.noop, // When the content of a slide is done loading

    beforeShow: function (instance, current) {
      var fbc = $('.fancybox-container');

      //console.log(current.opts.$orig)
      if (!fbc.length || !current || !current.opts || !current.opts.$orig || typeof current.opts.$orig !== 'object') return;

      if (current.opts.$orig.is('.fancybox__white') || current.opts.$orig.find('img').is('.fancybox__white')) {
        //console.log(fbc)
        fbc.addClass('fancybox__white');
      }
      else {
        fbc.removeClass('fancybox__white');
      }

      //carousels interaction
      //console.log('fancybox.show');
      //$(window).on('fancybox.show', function () { console.log('window: fancybox.show') });
      $(window).trigger('fancybox.show');

    }, // Before open animation starts

    //afterShow: $.noop, // When content is done loading and animating
    afterShow: function () {
      //carousels interaction
      //console.log('fancybox.shown');
      //$(window).on('fancybox.shown', function () { console.log('window: fancybox.shown') });
      $(window).trigger('fancybox.shown');
    },

    beforeClose: $.noop, // Before the instance attempts to close. Return false to cancel the close.
    afterClose: $.noop, // After instance has been closed
//     afterClose: function (instance, current) {
//       setTimeout(function () { current.opts.$orig.blur(); }, 300);
//     },

    onActivate: $.noop, // When instance is brought to front
    onDeactivate: $.noop, // When other instance has been activated


    // Interaction
    // ===========

    // Use options below to customize taken action when user clicks or double clicks on the fancyBox area,
    // each option can be string or method that returns value.
    //
    // Possible values:
    //   'close'           - close instance
    //   'next'            - move to next gallery item
    //   'nextOrClose'     - move to next gallery item or close if gallery has only one item
    //   'toggleControls'  - show/hide controls
    //   'zoom'            - zoom image (if loaded)
    //   false             - do nothing

    // Clicked on the content
    clickContent: function (current, event) {
      //return current.type === 'image' ? 'zoom' : false;
      return current.type === 'image' ? 'close' : false;
    },

    // Clicked on the slide
    //default is 'close'
    clickSlide: 'close',

    // Clicked on the background (backdrop) element;
    // if you have not changed the layout, then most likely you need to use `clickSlide` option
    //default is 'close'
    clickOutside: 'close',

    // Same as previous two, but for double click
    //default is false
    dblclickContent: false,
    dblclickSlide: false,
    dblclickOutside: false,


    // Custom options when mobile device is detected
    // =============================================

    mobile: {
      preventCaptionOverlap: false,
      idleTime: false,
      clickContent: function (current, event) {
        //return current.type === 'image' ? 'toggleControls' : false;
        return current.type === 'image' ? 'close' : false;
      },
      clickSlide: function (current, event) {
        //return current.type === 'image' ? 'toggleControls' : 'close';
        return current.type === 'image' ? 'close' : 'close';
      },
      dblclickContent: function (current, event) {
        return current.type === 'image' ? 'zoom' : false;
      },
      dblclickSlide: function (current, event) {
        //return current.type === 'image' ? 'zoom' : false;
        return false;
      }
    },


    // Internationalization
    // ====================

    lang: typeof window.LANG === 'string' ? window.LANG : 'en',
    i18n: {
      en: {
        CLOSE: 'Close',
        NEXT: 'Next',
        PREV: 'Previous',
        ERROR: 'The requested content cannot be loaded. <br/> Please try again later.',
        PLAY_START: 'Start slideshow',
        PLAY_STOP: 'Pause slideshow',
        FULL_SCREEN: 'Full screen',
        THUMBS: 'Thumbnails',
        DOWNLOAD: 'Download',
        SHARE: 'Share',
        ZOOM: 'Zoom'
      },
      cs: {
        CLOSE: 'Zavřít',
        NEXT: 'Další',
        PREV: 'Předchozí',
        ERROR: 'Nepodařilo se načíst zdroj. <br/> Zkuste to prosím později.',
        PLAY_START: 'Spustit slideshow',
        PLAY_STOP: 'Zastavit slideshow',
        FULL_SCREEN: 'Celá obrazovka',
        THUMBS: 'Náhledy',
        DOWNLOAD: 'Stáhnout',
        SHARE: 'Sdílet',
        ZOOM: 'Zoom'
      }
    }

  });
}
